import { render } from "./BrandRankingsHeatmap.vue?vue&type=template&id=34256779&scoped=true"
import script from "./BrandRankingsHeatmap.vue?vue&type=script&lang=js"
export * from "./BrandRankingsHeatmap.vue?vue&type=script&lang=js"

import "./BrandRankingsHeatmap.vue?vue&type=style&index=0&id=34256779&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34256779"]])

export default __exports__